export const loginEn = {
  "Username": "Username",
  "Password": "Password",
  "Connecter": "Connecter",
  "Wrong Data !": "Wrong Data !",
  "Wrong Data !!": "Wrong Data !!",
}